import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'UserEmail' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        justifyContent: 'space-between',
        gap: 8
    },
    email: {
        flex: 1,
        display: 'block',
        overflow: 'hidden',
        color: '#8E8E8E',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px',
        userSelect: 'none'
    },
    logout: {
        width: 16,
        height: 16,
        color: '#8E8E8E',
        transition: 'all 0.2s',
        borderRadius: 2,
        ['&:hover:not(:active)']: {
            color: '#5F5F5F'
        },
        ['&:active']: {
            background: '#EBE8E5'
        },
        ['&:disabled']: {
            opacity: 0.5
        }
    }
});
